// extracted by mini-css-extract-plugin
export var activeDot = "_8z-c";
export var buttonContainer = "_8z-9";
export var channelButton = "_8z-a";
export var clickable = "_8z-d";
export var content = "_8z-0";
export var contentFull = "_8z-2";
export var contentThird = "_8z-1";
export var contentWrapper = "_8z-7";
export var description = "_8z-5";
export var heightShort = "_8z-f";
export var image = "_8z-3";
export var imageContainer = "_8z-4";
export var selectButton = "_8z-e";
export var spinnerContainer = "_8z-b";
export var titleContent = "_8z-8";
export var titleWrapper = "_8z-6";